import styles from './MediaCardSection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";

class MediaCardSection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get alignMedia() {
        return this.dataset.alignMedia ?? 'left';
    }

    get headerVariant() {
        return this.dataset.headerVariant ?? 'vertical';
    }

    get isVideo(): boolean {
        return this.querySelector('[slot=video]') !== null;
    }

    render() {
        const container = document.createElement('div');
        container.innerHTML = `
            <header></header>
            <div class="image-with-card-section media-align-${this.alignMedia} media-${this.isVideo ? 'video' : 'image' }">
                <div class="media">
                    <slot name="video"></slot>
                </div>
                <div class="content"></div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        container.querySelector('header').append(this.createHeader(this.headerVariant));
        this.cloneSlotContentIntoContainer(container.querySelector('.media'), 'media', false);
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.content'));
        return container;
    }

}

customElements.define('nxt-media-card-section', MediaCardSection);
